var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.991 18.7256C8.991 23.6954 13.0338 27.7382 18.0036 27.7382C22.9734 27.7382 27.0162 23.6954 27.0162 18.7256C27.0162 13.7558 22.9734 9.71299 18.0036 9.71299C13.0338 9.71299 8.991 13.7558 8.991 18.7256ZM16.2 31.3256H19.8V36.7256H16.2V31.3256ZM16.2 0.725586H19.8V6.12559H16.2V0.725586ZM0 16.9256H5.4V20.5256H0V16.9256ZM30.6 16.9256H36V20.5256H30.6V16.9256ZM6.5466 32.726L4.0014 30.1808L7.8192 26.363L10.3644 28.9082L6.5466 32.726ZM25.6356 8.54479L29.4552 4.72519L32.0004 7.27039L28.1808 11.09L25.6356 8.54479ZM7.8192 11.0918L4.0014 7.27219L6.5484 4.72699L10.3644 8.54659L7.8192 11.0918ZM32.0004 30.1808L29.4552 32.726L25.6356 28.9064L28.1808 26.3612L32.0004 30.1808Z",
    fill: "#B7B7B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.25299635c18e75f90aba220b7cccef72.svg";
export { ForwardRef as ReactComponent };